/**
 * Break-glass wrapper around the pickup-date section on the details screen.
 *
 * Two things no ui-core primitive can do:
 *  - Expose its DOM node. The "your pickup date is a holiday" warning scrolls
 *    the picker into view, which needs a real element ref; Stack/Row/Panel
 *    don't forward one.
 *  - Stay full width. The details screen centres its sections, and a centred
 *    flex column makes every child shrink-wrap — without `w-full` this section
 *    would sit narrower than its siblings.
 */

import type { ReactNode, Ref } from "react";

interface BookShipmentDetailsDateAnchorProps {
  anchorRef: Ref<HTMLDivElement>;
  children: ReactNode;
}

export function BookShipmentDetailsDateAnchor({
  anchorRef,
  children,
}: BookShipmentDetailsDateAnchorProps) {
  return (
    <div ref={anchorRef} className="w-full">
      {children}
    </div>
  );
}
